// These are used for Active Storage Dropzone Stimulus controller

export const MB                         = 1024 * 1024
export const DEFAULT_UPLOAD_MAX_SIZE_MB = 5

export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`)
  if (element) {
    return element.getAttribute("content")
  }
}

export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root
    root = document
  }
  return root.querySelector(selector)
}

export function toArray(value) {
  if (Array.isArray(value)) {
    return value
  } else if (Array.from) {
    return Array.from(value)
  } else {
    return [].slice.call(value)
  }
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export const parseMoney = ( cents, currency_iso, { round } = {} ) => {
  const style = 'currency'
  const value = parseFloat(cents)
  const options = round
    ? { style, currency: currency_iso, minimumFractionDigits: 0, maximumFractionDigits: 0 }
    : { style, currency: currency_iso }
  return (round ? Math.round(value) : value).toLocaleString(I18n.locale, options)
}
